import { useStaticQuery, graphql } from 'gatsby';

export const useLocalizedSiteBottom = (selectedLocale) => {
  const {
    allPrismicSiteBottom: { edges: siteBottoms },
  } = useStaticQuery(graphql`
    {
      allPrismicSiteBottom {
        edges {
          node {
            lang
            data {
              sitemap_title
              sitemap {
                title
                link {
                  url
                  link_type
                  target
                }
              }
              contacts_title
              contacts {
                title
                link {
                  url
                  link_type
                }
              }
              social_links {
                title
                href {
                  url
                }
                icon {
                  alt
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 25, height: 25)
                    }
                    url
                    extension
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return siteBottoms.filter(({ node }) => node.lang === selectedLocale);
};
